<template>
  <div class="entry">
    <h5 class="label">
      <Trans>
        <template v-slot:en>
          {{labelEn}}
        </template>
        <template v-slot:jp>
          {{labelJp}}
        </template>
      </Trans>
    </h5>
    <div contenteditable="true" class="content" ref="content" onclick="document.execCommand('selectAll',false,null)">
      {{value}}
    </div>
  </div>
</template>

<script>
  import Trans from '../../components/text/Trans'

  export default {
    name: 'AboutEntry',
    components: { Trans },
    props: {
      labelEn: { type: String },
      labelJp: { type: String },
      value: { type: String }
    }
  }
</script>

<style scoped>
  .entry {

  }

  .label {
    margin: 0;
    padding: 0;
    font-size: 14px;
  }

  .content {
    font-size: 14px;
  }
</style>
